<template>
  <div v-if="links.length > 0" class="youtube-list">
    <!-- D: PC만 노출 -->
    <ul class="only-pc">
      <VideoLinkTabPcRow
        v-for="link in props.links"
        :key="link.linkUrlSn"
        :link="link"
        @request-play="(link) => showPlayPop(link)"
      />
    </ul>

    <!-- D: MO만 노출 -->
    <ul class="only-mo">
      <VideoLinkTabMobileRow
        v-for="link in props.links"
        :key="link.linkUrlSn"
        :link="link"
      />
    </ul>
  </div>

  <!-- D: data가 없을 때 -->
  <div v-else class="c-no-data-box type-no-line">
    <div class="icon-box">
      <i class="c-icon icon-nodata size-large"></i>
    </div>
    <p class="text">등록된 영상이 없습니다.</p>
  </div>

  <VideoLinkPlayPop
    v-if="iShowPlayPop"
    :is-double-layer="true"
    :link="playLink"
    @close="onCloseVideoLinkPlayPop"
  />
</template>
<script setup>
import { defineProps, onMounted, ref } from "vue";
import VideoLinkTabPcRow from "@/components/paintpro/prod/videoLinkTabPcRow.vue";
import VideoLinkTabMobileRow from "@/components/paintpro/prod/videoLinkTabMobileRow.vue";
import VideoLinkPlayPop from "@/components/paintpro/prod/videoLinkPlayPop.vue";

const props = defineProps({
  links: {
    type: Array,
    required: true,
  },
});

const iShowPlayPop = ref(false);
const playLink = ref(null);

onMounted(() => {});

const showPlayPop = (link) => {
  playLink.value = link;
  iShowPlayPop.value = true;
};

const onCloseVideoLinkPlayPop = () => {
  iShowPlayPop.value = false;
  document.documentElement.classList.remove("popup-open");
};
</script>
